import { FSAWithPayload } from '@collaborator/npm_modules/dist/components/redux';
import { APP_REMOVE_ALERT } from 'moduleBase/constants';
import { RemoveAlertPayloadType } from 'moduleBase/actions/types/RemoveAlertPayloadType';

const appRemoveAlert = (key: string): FSAWithPayload<RemoveAlertPayloadType> => ({
  type: APP_REMOVE_ALERT,
  payload: {
    key,
  },
});

export { appRemoveAlert };
